import { combineReducers } from 'redux';
import axios from 'axios';
import _ from 'lodash';
import * as Urls from 'src/constants/EndpointUrls';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { listReducer, itemReducer } from 'src/reducers/common';
import { fetchList,
         fetchListSuccess, 
         fetchListFailure, 
         setExtras, 
         setList,
         getExtras,
         getList 
} from 'src/reducers/common/listReducer';
import { setStatus, isJobSuccess, isJobIncomplete, fetchJobStatus } from 'src/reducers/JobStatus';
import { MAX_POLLING_INTERVAL } from 'src/constants/Generals';
import { setGlobalErrors } from 'src/reducers/global';
import { redirectTo } from 'src/utils/Http';

export const REDUCER_NAME = 'yearEndReportWithholdingReport';
export const getWithholdingReportList = state => getList(REDUCER_NAME, state);

export const fetchWithholdingReports = queries => async dispatch => {
  try {
    dispatch(fetchList(REDUCER_NAME));
    const response = await axios.get(Urls.SEARCH_WITHHOLDING_REPORT, {params: queries})
    const { totalCount = 0, displayFrom = 0, displayTo = 0 } = response.data.payload;
    const payload = {
      data: response.data.payload.employees,
      pageCount: response.data.payload.totalPages,
      totalCount,
      displayFrom,
      displayTo
    };
    dispatch(fetchListSuccess(REDUCER_NAME, payload));
    dispatch(setExtras(REDUCER_NAME, { year: queries.year }));
  } catch (e) {
    dispatch(fetchListFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const getBatchPdfParams = state => {
  const employees = getWithholdingReportList(state);
  const year = _.get(getExtras(REDUCER_NAME, state), 'year');
  return { employeeIds: employees.map(employee => employee.id).join(','), year };
};

// PDF一括作成 pdf batch create
export const createPdf = (params, hideModal) => async (dispatch, getState) => {
  try {
    const state = getState();
    const jobStatusHash = state.JobStatus;
    const response = await axios.post(Urls.WITHHOLDING_REPORT_CREATE_BATCH_PDF, params);
    jobStatusHash.exportWithholdingReportPdfJob = response.data.payload.jobStatus;
    dispatch(setStatus(jobStatusHash));
    dispatch(setExtras(REDUCER_NAME, { isCreating: true }));
    dispatch(setExtras(REDUCER_NAME, { isCreated: false }));
    hideModal();
  } catch (e) {
    dispatch(setGlobalErrors(e.response.data.errors.messages));
  }
};

// ジョブステータス取得 get job status
export const fetchExportWithholdingReportsJobStatus = (interval, year, uniqueString) => async (dispatch, getState) => {
  try {
    if (_.isUndefined(year) || _.isUndefined(uniqueString)) {
      return;
    }
    const params = { 
      job_name: 'exportWithholdingReportPdfJob',
      search_params: {
        year,
        unique_string: uniqueString
      }
    };
    await dispatch(fetchJobStatus(params));
    if (isJobIncomplete(getState().JobStatus.exportWithholdingReportPdfJob.status) === true) {
      const nextInterval = interval < MAX_POLLING_INTERVAL ? interval * 2 : interval;
      setTimeout(() => {
        dispatch(fetchExportWithholdingReportsJobStatus(nextInterval, year, uniqueString));
      }, nextInterval);
      dispatch(setExtras(REDUCER_NAME, { isCreating: true }));
      dispatch(setExtras(REDUCER_NAME, { isCreated: false }));
    } else if (isJobSuccess(getState().JobStatus.exportWithholdingReportPdfJob.status)) {
      dispatch(setExtras(REDUCER_NAME, { isCreating: false }));
      dispatch(setExtras(REDUCER_NAME, { isCreated: true }));
    } else {
      dispatch(setExtras(REDUCER_NAME, { isCreating: false }));
      dispatch(setExtras(REDUCER_NAME, { isCreated: false }));
    }
  } catch (e) {
    dispatch(setExtras(REDUCER_NAME, { isCreating: false }));
    dispatch(setExtras(REDUCER_NAME, { isCreated: false }));
    dispatch(setGlobalErrors('An error has occurred. Please reload the page.'));
  }
};

// PDF一括ダウンロード PDF bulk download
// 一括作成されたものをダウンロード Download the bulk created
export const fetchDownloadWithholdingReport = year => async dispatch => {
  try {
    const url = `${Urls.WITHHOLDING_REPORT_DOWNLOAD_PDF}?year=${year}`;
    redirectTo(url);
  } catch (e) {
    dispatch(setGlobalErrors('An error has occurred. Please reload the page.'));
  }
};

// PDF一括印刷 PDF bulk print
// 一括作成されたものを印刷 Print the bulk created
export const fetchPreviewWithholdingReport = year => async dispatch => {
  try {
    const url = `${Urls.WITHHOLDING_REPORT_PREVIEW_PDF}?year=${year}`;
    const w = window.open(url, '', 'toolbar=0,memubar=0,location=0');
    if (_.isFunction(w.addEventListener)) {
      w.addEventListener('load', () => {
        w.print();
      });
    }
  } catch (e) {
    dispatch(setGlobalErrors('An error has occurred. Please reload the page.'));
  }
};

export const getIsCreating = state => _.get(getExtras(REDUCER_NAME, state), 'isCreating');
export const getIsCreated = state => _.get(getExtras(REDUCER_NAME, state), 'isCreated');

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});